import { ErrorComponent } from './_components/error/error.component';
import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { HomeComponent } from './home';
import { PayStudentComponent } from './fee-payment/pay-student.component';
import { AuthGuard } from './_helpers';
import { FeePaymentModule } from './fee-payment/fee-payment.module';
import { FeeDetailsComponent } from './fee-details/fee-details.component';


const feeModule = () => import('./fee-payment/fee-payment.module').then(x=>FeePaymentModule);
const homeModule = () => import('./home/home.module').then(x=>HomeComponent);



const routes: Routes = [
    { path: '', component: FeeDetailsComponent},
    { path: 'error', component: ErrorComponent},
    { path: 'payment', loadChildren: feeModule },


    // otherwise redirect to home
    { path: '**', redirectTo: '' }
];

@NgModule({
    imports: [RouterModule.forRoot(routes)],
    exports: [RouterModule]
})
export class AppRoutingModule { }
